function debounce(fn, wait = 300) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
function throttle(func, interval = 100) {
    // A flag variable to track whether the function is running or not
    let isRunning = false;
    // Return a function that takes arguments
    return function(...args) {
        // If the function is not running
        if (!isRunning) {
            // Set the flag to true
            isRunning = true;
            // Apply the function with arguments
            func.apply(this, args);
            // Set a timer that will reset the flag after the interval
            setTimeout(() => {
                // Set the flag to false
                isRunning = false;
            }, interval);
        }
    };
}
  
function fetchConfig(type = 'json') {
    return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
}
  
// COOKIE Functions
function SetCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function GetCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function HasCookie(name) {
    return GetCookie(name) !== null;
}

function DeleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

// ParseBoolean 
function ParseBoolean(str) {
    return String(str).trim().toLowerCase() === "true";
}


// AppendClassNames for External Apps
function AppendClasses(selectorsAndClasses, Replace = false) {
    // Loop through each key-value pair in the input object
    for (const [selector, className] of Object.entries(selectorsAndClasses)) {
        // Perform a querySelectorAll search for the selector on the document body
        const elements = document.body.querySelectorAll(selector);
        
        // Iterate through each element found
        elements.forEach(element => {
            if (Replace) {
                // Remove all existing classes
                element.className = '';
            }
            // Split classNames into an array of individual class names
            const classesToAdd = className.split(',').map(className => className.trim());
            // Use spread syntax to pass each class as a separate argument
            element.classList.add(...classesToAdd);
        });
    }
}

// These are the Key Value Pair Targets Used with AppendClasses so for example .cc-btn Elements will Get Button, And ForceFont Classes appended to them
const ExternalClasses = {
    CookieClasses: {
        '.cc-btn': `Button,ForceFont`,
        '.cc-settings': 'Secondary',
        '.cc-btn-accept-selected': 'Secondary',
        '.cc-link': 'Link',
        '#cookieconsent\\:settings': 
            `${window?.theme?.Settings?.CookieBarColorScheme.id ?`ColorScheme-${window?.theme?.Settings?.CookieBarColorScheme?.id}` : '|'},
            ${window?.theme?.Settings?.CookieBarFontStyle || '|'},ForceFont`,
        '.cc-window': 
            `${window?.theme?.Settings?.CookieBarColorScheme.id ?`ColorScheme-${window?.theme?.Settings?.CookieBarColorScheme?.id}` : '|'},
            ${window?.theme?.Settings?.CookieBarFontStyle || '|'},ForceFont`,
        '.cookie-settings-header': `${window?.theme?.Settings?.CookieBarHeadingFontStyle || '|'},ForceFont`,
        '.cc-checkbox-container': `${window?.theme?.Settings?.CookieBarTitleFontStyle || '|'},ForceFont`,
        '.cc-cookie-category-text': `${window?.theme?.Settings?.CookieBarBodyFontStyle || '|'},ForceFont`,
        '.cc-consent-verification': `${window?.theme?.Settings?.CookieBarBodyFontStyle || '|'},ForceFont`,
    }
}

// Define the callback function for the MutationObserver
const HandleMutationCallback = function(mutationsList, observer) {
    if(document?.querySelector('.cc-window') || document?.querySelector('.cc-settings') ) {
        AppendClasses(ExternalClasses?.CookieClasses)
    }
};

// Create a MutationObserver instance
const observer = new MutationObserver(HandleMutationCallback);

// Configuration options for the observer (watch for added elements)
const config = { childList: true, subtree: true };

// Start observing the document body for DOM mutations
observer.observe(document.body, config);

// Remember to disconnect the observer when you no longer need it to prevent memory leaks
// observer.disconnect();




// Reusable Intersection and Resize functions to be consumed by web components
function AttachResizeObserver(Element, Options = {}) {
    if (!('ResizeObserver' in window)) {
        return console.warn('ResizeObserver is not available in this browser.')
    }

    const ResizeObserverInstance = new ResizeObserver(Entries => {
        for (let Entry of Entries) {
            Entry.target?.OnResize?.(Entry);
        }
    });

    ResizeObserverInstance.observe(Element, Options);
}

function AttachWindowResizeObserver(Element, Options = {}) {
    if (!('ResizeObserver' in window)) {
        return console.warn('ResizeObserver is not available in this browser.')
    }

    const ResizeObserverInstance = new ResizeObserver(Entries => {
        for (let Entry of Entries) {
            Element?.OnResize?.(Entry);
        }
    });

    ResizeObserverInstance.observe(document.documentElement, Options);
}

function AttachIntersectionObserver(Element, Options = {}) {
    if (!('IntersectionObserver' in window)) {
        return console.warn('IntersectionObserver is not available in this browser.')
    }

    const IntersectionObserverInstance = new IntersectionObserver(Entries => {
        for (let Entry of Entries) {
            Entry.target?.OnIntersect?.(Entry);
        }
    }, Options);

    IntersectionObserverInstance.observe(Element);
}

function UnLockScroll() {
    document.documentElement.classList.remove('Locked')
}

function LockScroll() {
    document.documentElement.classList.add('Locked')
}

function CheckValueAndSetClass(element) {
    const parent = element.closest('.FormField');
    if (element.value === '') {
        parent.classList.add('Empty');
    } else {
        parent.classList.remove('Empty');
    }
}

function AttachInputMonitors(element) {
    element.addEventListener('input', function() {
        CheckValueAndSetClass(element);
    })
    element.addEventListener('focus', function() {
        CheckValueAndSetClass(element);
    })
    element.addEventListener('blur', function() {
        CheckValueAndSetClass(element);
    })
    if (element.type === "password") {
        // console.log(element)
    }
}

// Shopify Common JS //
if (typeof window.Shopify == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = '';
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

if (!customElements.get('resize-reporter')) {
    class ResizeReporter extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.Initialize()
        }
        Initialize() {
            if (this.dataset.useWindow){
                AttachWindowResizeObserver(this)
            }else {
                AttachResizeObserver(this)
            }
            this.ElementScope = document?.querySelector?.(`${this.dataset.reportTo}`) || document.documentElement
        }
        OnResize(entry) {
            // This Gets called by the Global AttachResizeObserver Function
            if(this.dataset.axis === "Horizontal") {
                if(this.dataset.variable) {
                    this.ElementScope.style.setProperty(`--${this.dataset.variable}`, `${this.offsetWidth}px`);
                }
            } else {
                if(this.dataset.variable && this.offsetHeight) {
                    this.ElementScope.style.setProperty(`--${this.dataset.variable}`, `${this.offsetHeight}px`);
                }
            }
        }
    }

    customElements.define('resize-reporter', ResizeReporter);
}


//  Globally Defined Custom Elements
if(!customElements.get('image-element')){
    class ImageElement extends HTMLElement {
        constructor() {
            super()
        }
    
        connectedCallback() {
            this.Initialize()
        }
    
        static get observedAttributes() {
            return ['data-state']
        }
    
        attributeChangedCallback(attrName, oldValue, newValue) {
            if (attrName === 'data-state' && newValue == 'loaded') {
                this.RemoveLoader()
            }
        }
    
        Initialize() {
            this.Image = this.querySelector('img')
            this.Loader = this.querySelector('[data-loader]')
            if (this.Image) {
                this.dataset.state = "loading"
                this.Image.onload = () => {
                    this.ImageLoaded()
                }
                if (this.Image.complete) {
                    this.ImageLoaded()
                    return
                }
                if (this.ElementAboveTheFold(this.Image)) {
                    this.Image.loading = "eager"
                }
            }
        }
    
        ElementAboveTheFold(element) {
            const rect = element.getBoundingClientRect()
            return rect.bottom > 0 && rect.top < window.innerHeight
        }
    
        ImageLoaded() {
            this.dataset.state = "loaded"
        }
    
        RemoveLoader() {
            if (this.Loader && this.Loader.isConnected) { 
                this.removeChild(this.Loader)
            }
        }
    }
    customElements.define('image-element', ImageElement)
}
if(!customElements.get('notify-message')){
    class NotifyMessage extends HTMLElement {
        constructor() {
            super()
        }
    
        connectedCallback() {
            // console.log(this.dataset.title)
            // console.log(this.dataset.type)
            // console.log(this.innerHTML)
            setTimeout(() => {
                TriggerEvent('Notify', {Type: this.dataset.type, Title: this.dataset.title, Description: this.innerHTML})
            }, 1);
        }
    }
    customElements.define('notify-message', NotifyMessage)
}
if (!customElements.get('header-group')) {
    class HeaderGroup extends HTMLElement {
        constructor() {
            super();
        }

        static get observedAttributes() {
            return ['data-color'];
        }

        attributeChangedCallback(attrName, oldValue, newValue) {
            if (attrName === 'data-color') {
                // noop
            }
        }

        connectedCallback() {
            this.Initialize();
        }

        Initialize() {
            theme.HeaderGroup = this;

            // SAFELY QUERY (may be null if hidden in editor)
            this.AnnouncementBar = this.querySelector('#AnnouncementBar') || null;
            this.Header = this.querySelector('#Header') || null;

            this.EventUnSubscriber = SubscribeToEvent(`HeaderDrawerEvent`, (eventData) => {
                this.OnEvent(eventData);
            });

            this.ReOrderAnnouncementBar();

            AttachWindowResizeObserver(this);
            AttachResizeObserver(this);

            this.SetHeaderSpacer();

            if (document.querySelectorAll('[data-section-color=Dark]').length > 0) {
                this.AttachHeaderColorDetector();
            }
        }

        OnEvent(eventData) {
            if (eventData?.open === true) {
                this.dataset.drawer = 'Active';
            } else if (eventData?.close === true) {
                this.dataset.drawer = 'InActive';
            }
        }

        SetHeaderSpacer() {
            if (!this.dataset.exclusions || !this.dataset.exclusionsMobile) return;

            const DesktopClassExclusions = this.dataset.exclusions
                .trim()
                .split(',')
                .filter(Boolean);

            const MobileClassExclusions = this.dataset.exclusionsMobile
                .trim()
                .split(',')
                .filter(Boolean);

            const HeaderSpacerDesktop = document.querySelector('[data-header-spacer-desktop]');
            const HeaderSpacerMobile = document.querySelector('[data-header-spacer-mobile]');
            const FirstElement = document.querySelector('#MainContent')?.children?.[2];

            if (!FirstElement) return;

            function ProcessExclusions(exclusions, classList) {
                return exclusions.some(segment => {
                    const parts = segment.split('.');
                    return parts.every(part => classList.contains(part));
                });
            }

            Array.from(FirstElement.children).forEach(child => {
                const classList = child.classList;
                if (!classList) return;

                if (HeaderSpacerDesktop && ProcessExclusions(DesktopClassExclusions, classList)) {
                    HeaderSpacerDesktop.style.display = 'none';
                }

                if (HeaderSpacerMobile && ProcessExclusions(MobileClassExclusions, classList)) {
                    HeaderSpacerMobile.style.display = 'none';
                }
            });
        }

        ReOrderAnnouncementBar() {
            // 🔒 CRITICAL FIX — prevents literal "null" text node
            if (!this.AnnouncementBar) return;

            if (this.children[0]?.contains(this.AnnouncementBar)) {
                return;
            }

            this.prepend(this.AnnouncementBar);
        }

        OnResize(entry) {
            this.UpdateTargetElementColor();

            if (this.dataset.axis === 'Horizontal') {
                if (this.dataset.variable) {
                    document.documentElement.style.setProperty(
                        `--${this.dataset.variable}`,
                        `${this.offsetWidth}px`
                    );
                }
            } else {
                if (this.dataset.variable && this.offsetHeight) {
                    document.documentElement.style.setProperty(
                        `--${this.dataset.variable}`,
                        `${this.offsetHeight}px`
                    );
                }
            }
        }

        FindCurrentSection(TargetElement) {
            const Sections = document.querySelectorAll('[data-section-color]');
            let CurrentSection = null;
            let maxOverlap = 0;

            Sections.forEach(section => {
                const targetRect = TargetElement.getBoundingClientRect();
                const sectionRect = section.getBoundingClientRect();

                const overlap =
                    Math.max(0, Math.min(targetRect.right, sectionRect.right) - Math.max(targetRect.left, sectionRect.left)) *
                    Math.max(0, Math.min(targetRect.bottom, sectionRect.bottom) - Math.max(targetRect.top, sectionRect.top));

                const overlapRatio = overlap / (targetRect.width * targetRect.height);

                if (overlapRatio > maxOverlap) {
                    maxOverlap = overlapRatio;
                    CurrentSection = section;
                }
            });

            return CurrentSection;
        }

        UpdateTargetElementColor() {
            const currentSection = this.FindCurrentSection(this);
            if (currentSection) {
                this.dataset.color = currentSection.getAttribute('data-section-color');
            }
        }

        AttachHeaderColorDetector() {
            window.addEventListener('scroll', () => this.UpdateTargetElementColor());
        }
    }

    customElements.define('header-group', HeaderGroup);
}
if(!customElements.get('form-wrapper')){
    class FormWrapper extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {
            this.Enabled = ParseBoolean(this?.dataset?.enabled);
            this.Form = this.querySelector('form');
            this.FormAction = this?.Form?.getAttribute('action') || '';
            this.FormMethod = this?.Form?.getAttribute('method') || '';
            this.submitButton = this.querySelector('[type="submit"]');
            this.SuccessNotify = {
                Title: this?.dataset?.successTitle,
                Description: this?.dataset?.successDescription
            };
            this.ErrorNotify = {
                Title: this?.dataset?.errorTitle,
                Description: this?.dataset?.errorDescription
            };

            if (!this.Form) {
                console.warn('Missing Form For', this);
                return;
            }

            // 🚫 DO NOT INTERCEPT SHOPIFY AUTH FORMS
            const shopifyAuthActions = [
                '/account/login',
                '/account/register',
                '/account/recover',
                '/account/reset',
                '/guest_login'
            ];

            if (shopifyAuthActions.some(path => this.FormAction.includes(path))) {
                // Allow native submit (CAPTCHA + Shopify security)
                return;
            }

            if (!this.Enabled) {
                return;
            }

            if (!this.FormMethod) {
                console.warn('Missing Form Method For', this);
                return;
            }

            this.Form.addEventListener('submit', async (event) => {
                event.preventDefault();
                await this.handleSubmit();
            });
        }
        
        async handleSubmit() {
            const formData = new FormData(this.Form);

            const response = await fetch(this.FormAction, {
                method: this.FormMethod,
                ...(this.FormMethod.toLowerCase() !== 'get' && { body: formData })
            });

            if (response.ok && response.redirected) {
                window.location.href = response.url;
                return;
            }

            if (response.ok) {
                this.handleSuccess(response);
            } else {
                const errorData = await response.text();
                this.handleError(errorData);
            }
        }

        handleSuccess(response) {
            // optional notify hook
        }
    
        handleError(errorData) {
            // optional notify hook
        }
    }

    customElements.define('form-wrapper', FormWrapper);
}
if (!customElements.get('custom-select')) {
    class CustomSelect extends HTMLElement {
        constructor() {
            super();
            this.isOpen = false;
            this.currentlySelected = null;
            this.typedKeys = [];
            this.handleClickOutside = this.handleClickOutside.bind(this);
        }

        connectedCallback() {
            this.hiddenSelect = this.querySelector('select');
            if (!this.hiddenSelect) {
                console.warn('No hidden select found for', this);
                return;
            }

            this.render();
            this.addEventListeners();
            this.setDefaultSelection();
        }

        disconnectedCallback() {
            document.removeEventListener('click', this.handleClickOutside);
            document.removeEventListener('keyup', this.ThrottledKeyPress.bind(this))
        }

        render() {
            const dropDownContentWrapper = this.querySelector('[data-inner-content]');

            // Populate custom options
            dropDownContentWrapper.innerHTML = `
                ${Array.from(this.hiddenSelect.options).map(option => `
                    <li class="DropDownOption" role="option" data-value="${option.value}">${option.text}</li>
                `).join('')}
            `;

            this.customSelect = this.querySelector('.DropDownTitle');
            this.customSelected = this.querySelector('.DropDownTitle');
            this.dropDownContentWrapper = dropDownContentWrapper;
        }

        addEventListeners() {
            document.addEventListener('click', this.handleClickOutside);
            this.querySelector('[data-opener]').addEventListener('click', this.toggleOptions.bind(this));

            this.ThrottledKeyPress = throttle((event) => {
                this.handleKeyboardNavigation(event);
            }, 10);
            document.addEventListener('keyup', this.ThrottledKeyPress.bind(this))
            this.dropDownContentWrapper.addEventListener('mouseover', this.hoverOption.bind(this));
        }

        setDefaultSelection() {
            const firstOption = this.dropDownContentWrapper.firstElementChild;
            if (firstOption) {
                this.currentlySelected = firstOption;
                this.currentlySelected.setAttribute('aria-selected', 'true');
            }
        }

        toggleOptions() {
            this.isOpen ? this.closeOptions() : this.openOptions();
        }

        openOptions() {
            this.isOpen = true;
            this.setAttribute('data-state', 'Open');
            this.querySelector('[data-content]').style.display = 'block';
            document.addEventListener('click', this.handleClickOutside);
            this.dropDownContentWrapper.addEventListener('click', this.selectOption.bind(this));
        }

        closeOptions() {
            this.isOpen = false;
            this.setAttribute('data-state', 'Closed');
            this.querySelector('[data-content]').style.display = 'none';
            document.removeEventListener('click', this.handleClickOutside);
            this.dropDownContentWrapper.removeEventListener('click', this.selectOption.bind(this));
            this.resetTypedKeys();
        }

        selectOption(event) {
            if (event.target.tagName === 'LI') {
                const value = event.target.getAttribute('data-value');
                this.customSelected.textContent = event.target.textContent;
                this.hiddenSelect.value = value;

                // Hide options after selection
                this.closeOptions();

                // Update selected state
                Array.from(this.dropDownContentWrapper.children).forEach(option => {
                    option.setAttribute('aria-selected', 'false');
                });
                event.target.setAttribute('aria-selected', 'true');
                this.currentlySelected = event.target;
            }
        }

        hoverOption(event) {
            if (event.target.tagName === 'LI') {
                this.updateCurrentlySelected(event.target);
            }
        }

        updateCurrentlySelected(option) {
            if (this.currentlySelected) {
                this.currentlySelected.setAttribute('aria-selected', 'false');
            }
            option.setAttribute('aria-selected', 'true');
            this.currentlySelected = option;
        }

        handleClickOutside(event) {
            if (!this.contains(event.target)) {
                this.closeOptions();
            }
        }

        handleKeyboardNavigation(event) {
            console.log(event)
            if (this.isOpen) {
                if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                    this.navigateOptions(event.key === 'ArrowDown');
                    event.preventDefault();
                } else if (event.key === 'Enter' || event.key === ' ') {
                    const selectedOption = this.currentlySelected;
                    if (selectedOption) {
                        selectedOption.click();
                    }
                    event.preventDefault();
                } else if (event.key === 'Escape') {
                    this.closeOptions();
                } else {
                    this.handleTyping(event.key);
                }
            }
        }

        navigateOptions(isDown) {
            let newOption;
            if (isDown) {
                newOption = this.currentlySelected ? this.currentlySelected.nextElementSibling : this.dropDownContentWrapper.firstElementChild;
            } else {
                newOption = this.currentlySelected ? this.currentlySelected.previousElementSibling : this.dropDownContentWrapper.lastElementChild;
            }
            if (newOption) {
                this.updateCurrentlySelected(newOption);
                newOption.scrollIntoView({ block: 'nearest' });
            }
            this.resetTypedKeys();
        }

        handleTyping(key) {
            console.log(key)
            console.log(this.typedKeys)
            if (key === 'Backspace') {
                this.typedKeys.pop();
            } else {
                this.typedKeys.push(key.toLowerCase());
            }

            const typedString = this.typedKeys.join('');
            const options = Array.from(this.dropDownContentWrapper.children);
            const matchingOption = options.find(option => option.textContent.toLowerCase().startsWith(typedString));

            if (matchingOption) {
                this.updateCurrentlySelected(matchingOption);
                matchingOption.scrollIntoView({ block: 'nearest' });
            } else {
                this.resetTypedKeys();
            }
        }

        resetTypedKeys() {
            this.typedKeys = [];
        }
    }

    customElements.define('custom-select', CustomSelect);
}

if(!customElements.get('product-recommendations')){
    class ProductRecommendations extends HTMLElement {
        constructor() {
        super();
        }
    
        connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
    
            fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
        
                    if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
        
                    // From fam-animate-in-view.js and fam-global-js
                    InitializeGridCascades?.()
                    InitializeAnimationElements?.()
                }
    
                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                this.remove();
                }
    
                if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
                }
            })
            .catch((e) => {
                console.error(e);
            });
        };
    
        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 1500px 0px' }).observe(this);
        }
    }
    
    customElements.define('product-recommendations', ProductRecommendations);
}

window.addEventListener('DOMContentLoaded', () => {
    const FormFieldsInputs = document.querySelectorAll('.FormField input, .FormField textarea')

    // Initial check for all `.Form` elements
    FormFieldsInputs.forEach(CheckValueAndSetClass)

    // Monitor value changes for all `.Form` elements
    FormFieldsInputs.forEach(AttachInputMonitors)
})
